import { Injectable } from '@angular/core'
import { Observable } from 'rxjs'
import { reduce, mergeMap } from 'rxjs/operators'

import { ApiService } from './api.service'
import { Store } from './store'

@Injectable({
  providedIn: 'root'
})
export class FeatureToggleService extends Store<any> {

  constructor(private api: ApiService) {
    super([])
  }

  public findCurrent(orgId: number): Observable<any> {
    return this.api.get(`feature_instances?organization_id=${orgId}`)
      .pipe(
        mergeMap((data) => data.result),
        reduce((acc, cur: any) => {
          acc[cur.key] = cur
          return acc
        }, { })
      )
  }

}
